// extracted by mini-css-extract-plugin
export var authorGroup = "OurStoryPage-module--authorGroup--eb2ac";
export var authorGroupContent = "OurStoryPage-module--authorGroupContent--b7306";
export var authorGroupLink = "OurStoryPage-module--authorGroupLink--74bd1";
export var contentarea = "OurStoryPage-module--contentarea--21d6d";
export var contenttext = "OurStoryPage-module--contenttext--d3bed";
export var date = "OurStoryPage-module--date--49173";
export var datetext = "OurStoryPage-module--datetext--e6095";
export var detailssectionitem = "OurStoryPage-module--detailssectionitem--1f36b";
export var metawrapper = "OurStoryPage-module--metawrapper--55f2f";
export var relatedwrapper = "OurStoryPage-module--relatedwrapper--f8e8b";
export var sharewrapper = "OurStoryPage-module--sharewrapper--d50ea";